import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, IconButton, Typography } from "@material-ui/core";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditTextField from "../../EditArticle/EditTextField";
import { updateArticlegroups, updateArticlegroupsTranslations } from "../../../store/articles/ArticlesApi";
import { useDialog } from "../../Dialogs/DialogProvider";
import { Close } from "@material-ui/icons";
import cloudStore from "../../../store/CloudStore";
import { getTranslationValue } from "../../../store/articles/ArticlesHelpers";
import EditColorPicker from "../../EditArticle/EditColorPicker";

const useStyles = makeStyles(() => ({
  listAllergens: {
    display: "flex",
  },
  marginBottom10: {
    marginBottom: 10,
  },
  padding10: {
    padding: 10,
  },
}));

function ArticlegroupDetailsDialog(props) {
  const classes = useStyles();
  const [, closeDialog] = useDialog();

  const updateTranslations = (value) => {
    const translationsObject =
      props.articlegroup.translation_id && articlesStore.translations[props.articlegroup.translation_id]
        ? articlesStore.translations[props.articlegroup.translation_id]
        : {};
    return updateArticlegroupsTranslations(
      articlesStore.merchantId,
      [props.articlegroup],
      [{ translation: { [props.currentLanguage]: value } }],
      translationsObject
    ).then(Promise.resolve());
  };

  if (props.articlegroup == null) {
    return <div></div>;
  }

  return (
    <>
      <DialogTitle id="form-dialog-title">
        <div style={{ display: "flex", alignItems: "baseline" }}>
          <Typography variant={"h5"}>{props.intl.formatMessage({ id: "edit_articlegroup" })}</Typography>
        </div>
        <IconButton
          onClick={() => {
            closeDialog();
          }}
          color="primary"
          style={{ position: "absolute", top: "8px", right: "8px" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item container xs={12} alignContent={"flex-start"} spacing={1} className={classes.padding10}>
            <Grid item className={classes.marginBottom10} xs={12}>
              <EditTextField
                helperText={
                  isNaN(props.articlegroup.id) && props.intl.formatMessage({ id: "create_articles_to_save_changes" })
                }
                fullWidth
                authorizationField={"articlegroup.name"}
                label={props.intl.formatMessage({ id: "group_name" })}
                value={getTranslationValue("name", "translation_id", props.currentLanguage, props.articlegroup, "")}
                placeholder={props.articlegroup.name}
                onBlur={(newArticlegroupName, setBeginValue) => {
                  if (props.currentLanguage === cloudStore.merchant.default_language) {
                    updateArticlegroups(articlesStore.merchantId, [props.articlegroup], "name", [
                      newArticlegroupName,
                    ]).then(() => setBeginValue(newArticlegroupName));
                  } else {
                    updateTranslations(newArticlegroupName).then(() => setBeginValue(newArticlegroupName));
                  }
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={12}>
              <EditTextField
                fullWidth
                authorizationField={"articlegroup.pos_name"}
                label={props.intl.formatMessage({ id: "batch.pos_name" })}
                value={props.articlegroup.pos_name ?? ""}
                onBlur={(posName, setBeginValue) => {
                  updateArticlegroups(articlesStore.merchantId, [props.articlegroup], "pos_name", [posName]).then(() =>
                    setBeginValue(posName)
                  );
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid xs={12}>
              <Typography>{props.intl.formatMessage({ id: "handheld_background_color" })}</Typography>
              <EditColorPicker
                authorizationField={"article.handheld_bg_color"}
                value={props.articlegroup.handheld_bg_color}
                onChange={(value, setBeginValue) => {
                  updateArticlegroups(articlesStore.merchantId, [props.articlegroup], "handheld_bg_color", [
                    value,
                  ]).then(() => setBeginValue(value));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </>
  );
}

export default withIntl(ArticlegroupDetailsDialog);
